import { render, staticRenderFns } from "./color_group.vue?vue&type=template&id=4a96b0fd&scoped=true&"
import script from "./color_group.vue?vue&type=script&lang=ts&"
export * from "./color_group.vue?vue&type=script&lang=ts&"
import style0 from "./color_group.vue?vue&type=style&index=0&id=4a96b0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96b0fd",
  null
  
)

export default component.exports